// this is an autogenerated file from DesignSystem/TimelineEvent/FutureSeparator/Actions/AddAppointment/Add/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TimelineEvent_FutureSeparator_Actions_AddAppointment_Add_Content(
  $patient_id: uuid!
  $treatment_id: uuid!
  $appointment_type_id: uuid!
  $location_id: uuid!
  $previous_appointment_id: uuid
) {
  appointments_create_appointment(
    args: {
      _patient_id: $patient_id
      _treatment_id: $treatment_id
      _appointment_type_id: $appointment_type_id
      _location_id: $location_id
      _previous_appointment_id: $previous_appointment_id
      _unplanned: false
      _interval_to_next: 4
    }
  ) {
    id
  }
}

`